import axios from "./index";

export default {
  getAll(page, perPage, keyword) {
    return axios.get(`/v1/tat/event?page=${page}&perPage=${perPage}&keyword=${keyword}`);
  },
  getAllTatic(page, perPage, ids) {
    return axios.get(`/v1/tat/event-tatic?page=${page}&perPage=${perPage}&ids=${ids}`);
  },
  getDetail(uuid, language) {
    return axios.get(`/v1/tat/event/${uuid}?language=${language}`);
  },
  checkCloneEvent(uuid) {
    return axios.get(`/v1/tat/check-event/${uuid}`);
  },
  getProvince(name) {
    return axios.get(`/v1/tat/master/province?name=${name}`);
  },
  getCategory(name) {
    return axios.get(`/v1/tat/master/category?name=${name}`);
  },
  getAllApt(page, perPage, keyword, province) {
    return axios.get(`/v1/tat/apt?page=${page}&perPage=${perPage}&keyword=${keyword}&province=${province}`);
  },
  getAptDetail(documentId) {
    return axios.get(`/v1/tat/apt/${documentId}`);
  },
}